export default __webpack_public_path__ + "static/media/confetti.4589b377.png";